import React from 'react'
import Button from '../components/Button';
import CustomeIcon from '../components/CustomeIcon';
import DOMHandler from '../hooks/DOMHandler'

const Hotspots = (props) => {

  let productCategoryHotspotInfo = {}
  let categories=[];
  let hotspotClickOnly;
  let hotSpotText = ''
  let hotspotTextMainInternal;
  let internalHospotIdupdate;
  let checkId;
  let hotspotVisibleText;

  productCategoryHotspotInfo.hsname = props.id + "-hotspotBtn";
  productCategoryHotspotInfo.htmlid = props.id + "-hotspotBtn";
  productCategoryHotspotInfo.nameOf3dObj = props.nameOf3dObj;

  // productCategoryHotspotInfo.nameOf3dObj_right = props.nameOf3dObj_right;

  productCategoryHotspotInfo.hsgroup = 'productCategoryHotspot';
  productCategoryHotspotInfo.hstype = 'html';
  productCategoryHotspotInfo.htmlclass = 'productCategoryHotspot-btn';

  productCategoryHotspotInfo.xOffset = props.hotspotXoffset;
  productCategoryHotspotInfo.yOffset = props.hotspotYoffset;
  productCategoryHotspotInfo.minFadeAngleDeg = props.hotspotminFadeAngleDeg;
  productCategoryHotspotInfo.maxFadeAngleDeg = props.hotspotmaxFadeAngleDeg;
  // 
  productCategoryHotspotInfo.id1 = props.id1;
  // 
  // productCategoryHotspotInfo.isactive = props.isactive;
// if(props.hotspotsData != undefined){
//   console.log('props?.hotspotsData',props.hotspotsData);
// }
// console.log('props?.hotspotsData',props);

 if(props.id == "underTheCounterPedestalsCategory" && props.nameOf3dObj == 'Pedestals_HOTSPOT_01'){
  hotSpotText = props.pedestalsTextUpdate;
 } else {
  hotSpotText = props.hotspotsDataText;
 }


//  console.log("idTitle",props);
//  console.log("props.hotspotsData",props.hotspotsData);


  return (
    <>

      {props.hotspotsData == undefined ?


        <Button classList='hotspot productCategoryHotspot-btn showH'
          clickFunction={props.mainAccordionFunc}
          btnId={props.id + "-hotspotBtn"}
          data={props}
          info={productCategoryHotspotInfo}>

          <CustomeIcon src="./images/hotspot.svg"></CustomeIcon> <span className='hotspotTextmain'>
          {
              hotSpotText
              // props.hotspotsDataText
            }
          </span>
        </Button>

        :

<>
        <div className='hotspotContainer' id={props.id}>
          {
            props?.hotspotsData && props?.hotspotsData?.map((internalBtn, internalBtnindex) => {

              if (props.camSequence != null) internalBtn.camSequence = props.camSequence;
              if (props.menuItems != null) internalBtn.menuItems = props.menuItems;
              if (props.menuItemLength != null) internalBtn.menuItemLength = props.menuItemLength;
              if (props.CategoryTitile != null) internalBtn.CategoryTitile = props.CategoryTitile;
              if (props.id1 != null) internalBtn.id = props.id1;
              if (props.productStateSelectContext != null) internalBtn.productStateSelectContext = props.productStateSelectContext;
              if (props.camSequencetwo != null) internalBtn.camSequencetwo = props.camSequencetwo;
            

              let productTitle = props.id.split("-");

              let internalHotspotInfo = {}

              // console.log("internalHotspotInfo++++ hotspot.js",internalHotspotInfo);

              internalHotspotInfo.hsname = productTitle[0] + "-" + internalBtn.hotspotText.replace(/\s/g, '') + "-btn";
              internalHotspotInfo.htmlid = productTitle[0] + "-" + internalBtn.hotspotText.replace(/\s/g, '') + "-btn";
              
              internalHotspotInfo.nameOf3dObj = internalBtn.nameOf3dObj;

            

              internalHotspotInfo.hsgroup = 'internalHotspotInfo';
              internalHotspotInfo.hstype = 'html';
              internalHotspotInfo.htmlclass = 'internalHotspotInfo-btn';

              internalHotspotInfo.xOffset = internalBtn.hotspotXoffset;
              internalHotspotInfo.yOffset = internalBtn.hotspotYoffset;
              internalHotspotInfo.minFadeAngleDeg = internalBtn.hotspotminFadeAngleDeg;
              internalHotspotInfo.maxFadeAngleDeg = internalBtn.hotspotmaxFadeAngleDeg;

          
              categories= ['Walloven_Location_F_HOTSPOT_01','Walloven_Location_F_HOTSPOT_02','Walloven_Location_R_HOTSPOT_01','Walloven_Location_R_HOTSPOT_02','Pedestals_Location_R_HOTSPOT_01','Pedestals_Location_F_HOTSPOT_01'];

             


              if(categories.includes(internalHotspotInfo.nameOf3dObj)){
                hotspotClickOnly = props.mainAccordionFunc
              }
             else{
                hotspotClickOnly = props.internalHotspotClickHandler
             }

             if(props.id1 != "cooktopCategory"){
                 hotspotTextMainInternal =  internalBtn.hotspotText.replace(/-/g, '')
             }
             else if(props.id1 == "cooktopCategory"){
              hotspotTextMainInternal = internalBtn.hotspotText;
             }

            //  --------------------------------

            // console.log("props131",props);
            // console.log("hotspotTextMainInternal",hotspotTextMainInternal);


            if(hotspotTextMainInternal == "Control Panel Light"){
              hotspotVisibleText = "Control Panel & Light";
            }
            else if(hotspotTextMainInternal == "Crisper Fresh Converter Drawers"){
              hotspotVisibleText = "Crisper & Fresh Converter Drawers";
            }
            else{
              hotspotVisibleText = hotspotTextMainInternal;
            }
            //  if(props.id1 == "refrigeratorCategory"){
            //   // const reg1 = /\&/
            //   // checkId= productTitle[0] + "-" + internalBtn.hotspotText.replace(/\s/g, '') + "-btn"
            //   // internalHospotIdupdate =  checkId.replace(reg1, "-");
            //   // console.log("internalHospotIdupdate",internalHospotIdupdate)
            //   hotspotTextMainInternal = "";
            //  }
            //  else{
              internalHospotIdupdate = productTitle[0] + "-" + internalBtn.hotspotText.replace(/\s/g, '') + "-btn";
            //   hotspotTextMainInternal = hotspotTextMainInternal;
            //  }

            //  console.log("internalHospotIdupdate",internalHospotIdupdate)
           
              return (
                <React.Fragment key={internalBtnindex} >

                  
                  <Button
                    btnId={internalHospotIdupdate}
                    data={internalBtn}
                    info={{ ...internalHotspotInfo, 'hotspotText': internalBtn.hotspotText, 'hotspotTextActive': internalBtn.hotspotTextActive }}
                    // clickFunction={props.internalHotspotClickHandler}
                    clickFunction={hotspotClickOnly}
                    classList="hotspot hotspotInternalBtn"
                  >
                    <CustomeIcon src="./images/hotspot.svg" id={internalHospotIdupdate}></CustomeIcon> <span className="internalhotspotText" id={internalHospotIdupdate}>
                      {
                       hotspotVisibleText
                      // doubleDashId.includes(internalBtn.hotspotText) ? internalBtn.hotspotText.replace(/-/g, '') : internalBtn.hotspotText
                      }
                    </span>
                  </Button>

             

                </React.Fragment>
              )
            })
          }
        </div>

        {/* <div className='internalcallout pointes circle' id={props.idTitle}>
        {
          props?.hotspotsData && props?.hotspotsData?.map((internalBtn, internalBtnindex) => {
        console.log('idTitle',props.idTitle)
            if (props.menuItems != null) internalBtn.menuItems = props.menuItems;
            if (props.menuItemLength != null) internalBtn.menuItemLength = props.menuItemLength;
            if (props.CategoryTitile != null) internalBtn.CategoryTitile = props.CategoryTitile;
            if (props.productStateSelectContext != null) internalBtn.productStateSelectContext = props.productStateSelectContext;
          //   if (props.camSequencetwo != null) internalBtn.camSequencetwo = props.camSequencetwo;
            let internalHotspotInfo = {}
            console.log("internalHotspotInfo++++=======",internalHotspotInfo)
            console.log("internalBtn++++=======",internalBtn);



            internalHotspotInfo.hsname = props.idTitle.replace(/ /g, '') + "-btn";     
            internalHotspotInfo.htmlid = props.idTitle.replace(/ /g, '') + "-btn";

            internalHotspotInfo.nameOf3dObj = internalBtn.whiteBubbleHotspot;
            internalHotspotInfo.hsgroup = 'internalHotspotInfo';
            internalHotspotInfo.hstype = 'html';
            internalHotspotInfo.htmlclass = 'internalHotspotInfo-btn';

            internalHotspotInfo.xOffset = internalBtn.hotspotXoffset;
            internalHotspotInfo.yOffset = internalBtn.hotspotYoffset;
            internalHotspotInfo.minFadeAngleDeg = internalBtn.hotspotminFadeAngleDeg;
            internalHotspotInfo.maxFadeAngleDeg = internalBtn.hotspotmaxFadeAngleDeg;
        
            return (
              <React.Fragment key={internalBtnindex} >
                <Button
                  // btnId={productTitle[0] + "-" + internalBtn.hotspotText.replace(/\s/g, '') + "-btn"}
                  // data={internalBtn}
                  // info={{ ...internalHotspotInfo, 'hotspotText': internalBtn.hotspotText, 'hotspotTextActive': internalBtn.hotspotTextActive }}
                  info={{ ...internalHotspotInfo }}
                  // clickFunction={props.internalHotspotClickHandler}
                  // clickFunction={hotspotClickOnly}
                  classList="hotspot hotspotInternalBtn"
                >
                  <span className="internalhotspotText" id={internalBtn.hotspotText + "-btn"}>
                    {
                
                    internalBtn.hotspotText
                    }
                  </span>
                </Button>
              </React.Fragment>
            )
          })
        }
        </div> */}
</>
      }
    </>

  )
}

export default Hotspots